import { render, staticRenderFns } from "./transforvideo.vue?vue&type=template&id=520fff08&scoped=true&"
import script from "./transforvideo.vue?vue&type=script&lang=js&"
export * from "./transforvideo.vue?vue&type=script&lang=js&"
import style0 from "./transforvideo.vue?vue&type=style&index=0&id=520fff08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520fff08",
  null
  
)

export default component.exports